import { render, staticRenderFns } from "./Doors.vue?vue&type=template&id=5414e7ce&lang=pug&"
import script from "./Doors.vue?vue&type=script&lang=js&"
export * from "./Doors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports